export default "__VITE_ASSET__qQrwXar0__"